export default "__VITE_ASSET__wKH8OY7e__"